import { z } from 'zod';
/**
 * Geburtstags-Contracts (ADR-036). Einträge pflegen nur Eltern; alle sehen sie.
 * currentAge / nextRound* werden serverseitig berechnet (computeAge etc.).
 */
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Datum als YYYY-MM-DD');
/** Reichweite der Geburtstags-Benachrichtigung. */
export const BIRTHDAY_NOTIFY = ['all', 'adults', 'self', 'none'];
/** Anlass-Art: Geburtstag oder Jahrestag (gleiche Struktur, ADR-036). */
export const OCCASION_KINDS = ['birthday', 'anniversary'];
export const birthdayDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    birthdate: z.string(),
    hasYear: z.boolean(), // false wenn Jahr unbekannt (Konvention: 1900)
    currentAge: z.number().int().nullable(), // null ohne bekanntes Jahr
    nextBirthday: z.string(), // YYYY-MM-DD
    nextRoundAge: z.number().int().nullable(),
    nextRoundDate: z.string().nullable(),
    notify: z.enum(BIRTHDAY_NOTIFY),
    notifyMemberName: z.string().nullable(), // bei notify='self' der Name
});
export const createBirthdaySchema = z.object({
    name: z.string().min(1).max(80),
    birthdate: isoDate,
    notify: z.enum(BIRTHDAY_NOTIFY).optional(),
});
export const updateBirthdaySchema = createBirthdaySchema.partial();
//# sourceMappingURL=birthday.js.map